$(document).on('click', 'a.scrollTo', function (event)
{
    if (this.hash !== "") {
        event.preventDefault();
        let target = $(`.page-current .page-content ${this.hash}`);
        if (target) {
            let pageContent = target.parents('.page-content');
            pageContent.scrollTo(0, target.offset().top + pageContent.scrollTop() - 80, 800);
        }
    }
});